import { Component, input } from '@angular/core';

import { HexagonsComponent } from '../hexagons/hexagons.component';
import { ImpactTrackerLogoComponent } from '../logo/impact-tracker-logo.component';

@Component({
  selector: 'rt-impact-tracker-insights',
  templateUrl: './insights.component.html',
  styleUrl: './insights.component.less',
  imports: [ImpactTrackerLogoComponent, HexagonsComponent],
})
export class InsightsComponent {
  public logoHeading = input.required<string>();
  public subheading = input.required<string>();
}
